<template>
    <b-navbar-dropdown
        v-if="item.children && item.visible"
        :label="item.label"
    >
        <b-navbar-item
            v-for="itemChild in itemChildren"
            :key="itemChild.name"
            tag="router-link"
            exact-path
            active-class="is-active"
            :to="{ name: itemChild.name }"
        >
            {{ itemChild.label }}
        </b-navbar-item>
    </b-navbar-dropdown>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },

    computed : {
        itemChildren() {
            return _.filter(this.item.children, function(itemChild) {
                return itemChild.visible;
            });
        },
    },
};
</script>
